@if (parseRequestState()?.isLoading) {
  <app-edit-form-skeleton />
} @else if (!parseRequestState() || parseRequestState()?.error) {
  <ui-alert color="error">
    <ng-icon name="heroXCircle" size="20" slot="icon" class="!block" />
    {{ 'cockpit.parseRequests.details.general.loadError' | transloco }}
  </ui-alert>
} @else if (parseRequestState()?.data) {
  @if (parseRequestState()?.data; as parseRequest) {
    <app-parse-requests-details-edit-form
      [parseRequest]="parseRequest"
      [parseRequestId]="parseRequestId()"
      [organizationId]="organizationId()"
    />
  }
}
